"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function sassGlobPatternFactory(path) {
  return function (base) {
    var _path$parse = path.parse(base),
        name = _path$parse.name,
        ext = _path$parse.ext;

    return ext ? base : "?(_)".concat(name, "@(.css|.sass|.scss)");
  };
}

exports.sassGlobPatternFactory = sassGlobPatternFactory;